import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'

import { explorerApi } from '~/api/client'
import { deployedContractListKey } from '~/api/service/query-keys.const'
import { DeployedContractListModel } from '~/types/model/address.model'
import { IPagination } from '~/types/pagination.type'

export const addressService = {
  useGetDeployedContractList (pagination: Ref<IPagination>) {
    const getDeployedContractList = async () => {
      const res = await explorerApi.addressController.getContractCodeList1({
        requestBody: {
          page: pagination.value.page,
          size: pagination.value.rowPerPage,
        }
      })
      return new DeployedContractListModel(res as EvmDeployContractListInfo)
    }
    return useQuery([ ...deployedContractListKey, pagination ], getDeployedContractList)
  }
}